// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddCustomSlideToPresentationMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateClientPresentationV2Input;
}>;


export type AddCustomSlideToPresentationMutation = { __typename?: 'Mutation', updateClientPresentationV2: { __typename?: 'ClientPresentationV2', id: string, bundles: { __typename?: 'PresentationBundleConnection', edges?: Array<{ __typename?: 'PresentationBundleEdge', node?: { __typename?: 'PresentationBundle', id: string, kind: Types.PresentationBundleKind, pages: { __typename?: 'PresentationPageConnection', edges?: Array<{ __typename?: 'PresentationPageEdge', node?: { __typename?: 'PresentationPage', id: string, kind: Types.PresentationPageKind } | null } | null> | null } } | null } | null> | null } } };

export const Operations = {
  Mutation: {
    AddCustomSlideToPresentation: 'AddCustomSlideToPresentation' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const AddCustomSlideToPresentationDocument = gql`
    mutation AddCustomSlideToPresentation($input: AugmentedUpdateClientPresentationV2Input!) {
  updateClientPresentationV2(input: $input) {
    id
    bundles {
      edges {
        node {
          id
          kind
          pages {
            edges {
              node {
                id
                kind
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type AddCustomSlideToPresentationMutationFn = Apollo.MutationFunction<AddCustomSlideToPresentationMutation, AddCustomSlideToPresentationMutationVariables>;

/**
 * __useAddCustomSlideToPresentationMutation__
 *
 * To run a mutation, you first call `useAddCustomSlideToPresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCustomSlideToPresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCustomSlideToPresentationMutation, { data, loading, error }] = useAddCustomSlideToPresentationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCustomSlideToPresentationMutation(baseOptions?: Apollo.MutationHookOptions<AddCustomSlideToPresentationMutation, AddCustomSlideToPresentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCustomSlideToPresentationMutation, AddCustomSlideToPresentationMutationVariables>(AddCustomSlideToPresentationDocument, options);
      }
export type AddCustomSlideToPresentationMutationHookResult = ReturnType<typeof useAddCustomSlideToPresentationMutation>;
export type AddCustomSlideToPresentationMutationResult = Apollo.MutationResult<AddCustomSlideToPresentationMutation>;
export type AddCustomSlideToPresentationMutationOptions = Apollo.BaseMutationOptions<AddCustomSlideToPresentationMutation, AddCustomSlideToPresentationMutationVariables>;